module.exports = __webpack_public_path__ + "media/Participa-02-animation-mp4.b51f98d6.mp4";